import React from "react";
import { ReactComponent as NoDataPlaceholder } from "./no-data-charts.svg";
import "./NoData.scss";

const NoData = (props) => {
    return (
        <div className={`no-data-charts skiptranslate ${props.classname}`}>
            <NoDataPlaceholder />
            <p>{props.advanceChartNoDimensionsAndMetrics ? "Please select both dimensions and metrics" : props.message ? props.message : "No Data"}</p>
        </div>
    );
};

export default NoData;
